// What the correlation finder form reports about its pair: whether it can be analysed at all.

export const MAX_COMBINATIONS = 500

export const COMBINATIONS_ERROR = `Your selection exceeds the allowed number of combinations (${MAX_COMBINATIONS}). Please limit the answer choices for your banner and/or attribute, or choose a different banner/attribute combination.`

// A bare `true` marks an incomplete pair and draws no message; only the cap has something to say.
export const checkError = ({ batches, errors }) => {
  if (0 < errors.length || 2 != batches.length) return { error: true }
  if (batches.some(b => !b.answerVariants.length || b.answerVariants.some(av => !av.pattern.length)))
    return { error: true }
  if (MAX_COMBINATIONS < batches[0].answerVariants.length * batches[1].answerVariants.length)
    return { error: COMBINATIONS_ERROR }
  return { error: false }
}
